import { pipe, uniq } from 'ramda';
import { TaskField } from 'stores/fields';
import { Task } from 'stores/tasks';
import { AssigneeField, AssigneeValue } from '../../fields';
import { TaskUpdateRequest } from '../../use-update-tasks';

export const getTransformer =
  (assignees: AssigneeValue[]) =>
  (assignee: AssigneeField) =>
  (task: Task): TaskUpdateRequest => {
    const from = task.assignee ?? [];
    const to = pipe(
      () => from.slice(),
      (values) => values.concat(assignees),
      (values) => values.map(AssigneeValue.toString),
      (values) => uniq(values),
      (values) => values.map(AssigneeValue.fromString),
    );

    return {
      record: task as Record<string, unknown>,
      updates: [
        {
          field: assignee as TaskField,
          from,
          to: to(),
        },
      ],
    };
  };
